import { render, staticRenderFns } from "./RegulatoryUpdateWarning.vue?vue&type=template&id=3e39ea58&scoped=true&"
import script from "./RegulatoryUpdateWarning.vue?vue&type=script&lang=ts&"
export * from "./RegulatoryUpdateWarning.vue?vue&type=script&lang=ts&"
import style0 from "./RegulatoryUpdateWarning.vue?vue&type=style&index=0&id=3e39ea58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39ea58",
  null
  
)

export default component.exports